<div class="card">
	<div class="card-header mm-card-header">Upload CSV</div>
	<div class="card-body col-md-12">
		<div class="upload-csv row mb-5 d-flex justify-content-between">
			<p-fileupload #fileUpload data-identifier="upload-csv-select"
			              mode="basic" chooseLabel="Select File" accept=".csv" maxFileSize="1000000"
			              [multiple]="false" (onSelect)="onFileSelect($event)"/>
			<p-select [options]="bulkActionTypes" [(ngModel)]="selectedActionType" placeholder="Action"></p-select>
			<button data-identifier="upload-csv-button" [disabled]="isUploadDisabled()" type="button"
			        class="btn btn-sm btn-primary action-button" (click)="uploadFile()">Upload CSV
			</button>
			<button data-identifier="execute-bulk-button" type="button" [disabled]="isExecuteDisabled()"
			        class="btn btn-sm btn-primary action-button" (click)="executeJob()">Execute Job
			</button>
		</div>
		<p-table data-identifier="upload-csv-table" class="bulk-action-job-table" [value]="bulkActionJobs" (onLazyLoad)="customSort($any($event))"
                 [lazy]="true" sortMode="single" sortField="creationAudit.dateCreated" [sortOrder]="-1" [totalRecords]="totalItems"
                 [scrollable]="true" scrollHeight="650px" [tableStyle]="{'min-width': '65rem', 'table-layout': 'fixed'}">
			<ng-template pTemplate="header">
				<tr>
                    <th class="text-start ps-4" pSortableColumn="creationAudit.dateCreated" [ngStyle]="{'width':'10%'}" data-identifier="bulkaction-header-datecreated">
                        Date Created
                        <p-sortIcon field="creationAudit.dateCreated"></p-sortIcon>
                    </th>
                    <th class="text-start ps-4" pSortableColumn="dateProcessed" [ngStyle]="{'width':'12%'}" data-identifier="bulkaction-header-dateprocessed">
                        Date Processed
                        <p-sortIcon field="dateProcessed"></p-sortIcon>
                    </th>
                    <th pSortableColumn="fileName" [ngStyle]="{'width':'30%'}" [pSortableColumn]="'fileName'" data-identifier="bulkaction-header-filename">
                        File Name
                        <p-sortIcon field="fileName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="status" [ngStyle]="{'width':'10%'}" data-identifier="bulkaction-header-status">
                        Status
                        <p-sortIcon field="status"></p-sortIcon>
                    </th>
					<th scope="col" data-identifier="bulkaction-header-output">Output</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-job>
				<tr>
					<td data-identifier="bulkaction-datecreated">{{ job.dateCreated | formatDateArray }}</td>
					<td data-identifier="bulkaction-dateprocessed">{{ job.dateProcessed | formatDateArray }}</td>
					<td data-identifier="bulkaction-filename">{{ job.fileName }}</td>
					<td data-identifier="bulkaction-status">{{ job.status }}</td>
					<td data-identifier="bulkaction-output">
						<button data-identifier="bulkaction-output-download" class="download-link"
						        *ngIf="job.status === 'COMPLETED'"
						        (click)="downloadOutput(job.fileName)">Download
						</button>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr data-identifier="bulkaction-no-records">
					<td [attr.colspan]="5">
                        <lib-empty-state [message]="'No bulk jobs available. Please upload a csv for bulk action.'"/>
					</td>
				</tr>
			</ng-template>
            <ng-template pTemplate="footer">
                <tr data-identifier="table-footer">
                    <td [attr.colspan]="5">
                        <lib-pagination *ngIf="totalItems>0"
                                        #pagination
                                        [totalItems]="totalItems"
                                        [currentPage]="currentPage"
                                        (selectItemsPerPage)="onSelectItemsPerPage($event)"
                                        (changeCurrentPage)="onChangeCurrentPage($event)">
                        </lib-pagination>
                    </td>
                </tr>
            </ng-template>
		</p-table>
	</div>
</div>
